module.exports = __webpack_public_path__ + "img/thermometer-plus.6eac9b72.svg";